import styled from '@emotion/styled';


export const Box = styled.div`


  width: 386px;


background: none;
appearance: none;

  @media (max-width: 689px) {
 min-width: 300px;
     width:100%;
  } 

`;



export const Img = styled.img`

object-fit: contain;
border-radius: 40px;
margin-top: 10px;
width: 386px;
height: 184px;
margin-bottom: 16px;
  @media (max-width: 689px) {
    min-width: 300px;
     width:100%;
    margin-bottom: 0px;
  } 
`;
export const Title = styled.h2`
font-family: var(--font-family);
font-weight: 600;
font-size: 20px;
line-height: 135%;
text-align: center;
color: var(--colors-grey-900);
margin-bottom: 4px;
`;

export const Text = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-grey-600);
margin-bottom: 12px;
`;
export const WrapButton = styled.div`
display: flex;
gap: 12px;
width: 100%;
  @media (max-width: 689px) {
     flex-direction: column;
  } 
`;

export const YesButton = styled.button`
cursor: pointer;
border: 1px solid var(--colors-error-600);
border-radius: 360px;
padding: 8px 12px;
width: 187px;
height: 48px;
display: flex;
align-items: center;
justify-content: center;
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-error-600);
background: none;
  @media (max-width: 689px) {
     width: 100%;
  } 
`;

export const NoButton = styled.button`
cursor: pointer;
border-radius: 360px;
padding: 8px 12px;
width: 187px;
height: 48px;
display: flex;
align-items: center;
justify-content: center;
background: var(--colors-primary-600);
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-grey-25);
  @media (max-width: 689px) {
     width: 100%;
  } 
`;
